import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('crop-planning'));

export const CropPlanningPluginContainer: React.FC = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.cropPlanning.module-federation'];

  const CropPlanningPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('cropPlanning/CropPlanning'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return <CropPlanningPlugin />;
};
